<script>
    import {navigate} from 'svelte-routing';
    
    import TestType1 from './TestType1.svelte';
    import TestType2 from './TestType2.svelte';
    import TestType3 from './TestType3.svelte';
    import TestType4 from './TestType4.svelte';
    import TestType5 from './TestType5.svelte';
    import TestType6 from './TestType6.svelte';
    import TestType7 from './TestType7.svelte';
    import {api, store} from '../../stores.js';

    const user = store('credentials', 'appUserAuth');

    export let evid = '';
    export let tid = '';
    export let title = '';
    export let data;
    export let prev;

    let wrapper;
    let color = '', icon = '', label = '', message = '';
    let reward = async (state) => {
        if (typeof state === 'boolean') {
            switch (state) {
                case true: {
                    color = 'text-success';
                    icon = 'checkmark-circle';
                    label = 'Задание выполнено';
                    break;
                }
                case false: {
                    color = 'text-danger';
                    icon = 'close-circle';
                    label = 'Задание не выполнено';
                    break;
                }
            }
        }
        if (typeof state === 'number') {
            color = 'text-success';
            icon = 'checkmark-circle';
            label = 'Задание выполнено';
            
            if (prev === null) {
                message = 'Начислено ' + state + ' МИИНок';
    
                await api('addEventMembersTest', {
                    idEvent: evid,
                    idTest: (data.id ? data.id : tid),
                    nameTest: title,
                    email: ($user.email ? $user.email : ''),
                    test: +(state) + 256
                });
                await user.load({login: $user.email, password: $user.pasport});
            } else {
                message = [
                    'Результат: ' + state + ' баллов',
                    '(за повторное прохождение баллы не начисляются)'
                ].join('<br>');
            }
        }
        if (typeof state === 'string') {
            color = 'text-success';
            icon = 'checkmark-circle';
            label = 'Благодарим за участие';
            message = state;
    
            //if (prev === null) {
                await api('addEventMembersTest', {
                    idEvent: evid,
                    idTest: (data.id ? data.id : tid),
                    nameTest: title,
                    email: ($user.email ? $user.email : ''),
                    state: state.trim(),
                });
                await user.load({login: $user.email, password: $user.pasport});
            //}
        }
        
        (new bootstrap.Modal(document.getElementById('dialog-reward'))).show();
    };
    let handlerDone = () => {
        navigate('/events/view/' + evid + '/tests');
    };
</script>

<div class="section mt-3 mb-3" bind:this={wrapper}>
    {#if data}
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div data-type="{data.type}" {...$$restProps}>
                    {#if data.type.toString() === '1'}
                        <TestType1 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '2'}
                        <TestType2 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '3'}
                        <TestType3 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '4'}
                        <TestType4 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '5'}
                        <TestType5 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '6'}
                        <TestType6 {wrapper} {data} {reward} />
                    {/if}
                    {#if data.type.toString() === '7'}
                        <TestType7 {wrapper} {data} {reward} />
                    {/if}
                </div>
            </div>
        </div>
    {/if}
</div>

<!-- dialog-reward -->
<div class="modal fade dialogbox" id="dialog-reward" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon {color}">
                <ion-icon name="{icon}" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">{label}</h5>
            </div>
            <div class="modal-body">{@html message}</div>
            <div class="modal-footer">
                <div class="btn-inline">
                    <button class="btn" data-bs-dismiss="modal" on:click={handlerDone}>Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- * dialog-reward -->
